import { Box, Stack, useBreakpointValue } from '@chakra-ui/react'
import { H2, H3, H5, H6 } from 'components/typography'
import { FC } from 'react'

const SmartfitSection: FC = () => {
  const isMobile = useBreakpointValue({ base: true, lg: false })
  return (
    <Stack align="center" bg="alabaster" py={{ base: '24px', lg: '32px' }} px={{ base: '24px', lg: '64px' }}>
      <Stack spacing={6} maxW="1350px">
        <Box>
          {isMobile ? (
            <H3>
              O Smart Fit Nutri e a Omens se uniram para cuidar da sua saúde e bem-estar com condições exclusivas!
            </H3>
          ) : (
            <H2>
              O Smart Fit Nutri e a Omens <br /> se uniram para cuidar da sua saúde <br />e bem-estar com condições
              exclusivas!
            </H2>
          )}
        </Box>
        <Stack spacing={8}>
          <H6>
            Aproveite agora mesmo as ofertas especiais e garanta{' '}
            <Box as="span" bg="dandelion">
              10% de desconto
            </Box>{' '}
            já aplicado em todos os nossos produtos e serviços!
          </H6>
          <Box>
            <H5 mb={4}>Quer mais vantagens?</H5>
            <H6>
              Na compra dos suplementos <ProductLink href="mais-hair" title="+hair" />,{' '}
              <ProductLink href="mais-fert" title="+fert" /> ou <ProductLink href="mais-lib" title="+lib" />, use o
              cupom fornecido pelo seu nutricionista e aproveite ainda mais descontos para potencializar seus
              resultados.
            </H6>
          </Box>
          <H5>
            Tem alguma dúvida? Nossa equipe de suporte está pronta para ajudar você. Basta tocar no menu e falar com a
            gente!
          </H5>
        </Stack>
      </Stack>
    </Stack>
  )
}

export default SmartfitSection

interface ProductsLinkProps {
  href: string
  title: string
}
const ProductLink: FC<ProductsLinkProps> = ({ href, title }) => {
  return (
    <Box
      as="a"
      href={`/produtos/${href}`}
      borderBottom="2px"
      borderColor="dandelion"
      transition="0.3s ease-in-out"
      _hover={{ borderColor: 'transparent', bg: 'dandelion' }}
    >
      {title}
    </Box>
  )
}
